import { Controller } from "stimulus";
import Utility from '../classes/Utility';
import Events from '../classes/Events';
import axios from 'axios';

const hidePagePathname = ['pricing', 'login', 'legal'];
const userInput = {
  investor_type: null,
  email: null
}

// step actions
const step1 = (scope) => {
  scope.titleTarget.textContent = 'Please help us personalize your experience.';
  scope.subtitleTarget.textContent = 'Select the one that best describes you';
  scope.submitButtonTarget.classList.add('t-hidden');
  scope.investorTypeTarget.classList.remove('t-hidden');
  scope.emailTarget.classList.add('t-hidden');
  scope.goBackButtonTarget.classList.add('t-invisible');
  scope.goBackButtonTarget.removeEventListener('click', () => {
    scope.toStep(1);
  });
}

const step2 = (scope) => {
  scope.titleTarget.textContent = 'Your personalized experience is almost ready.';
  scope.subtitleTarget.textContent = 'Join other individual investors receiving free personalized market updates and research.';
  scope.submitButtonTarget.classList.remove('t-hidden');
  scope.investorTypeTarget.classList.add('t-hidden');
  scope.emailTarget.classList.remove('t-hidden');
  scope.goBackButtonTarget.classList.remove('t-invisible');
  scope.goBackButtonTarget.addEventListener('click', () => {
    scope.toStep(1)
  });
}

const step3 = (scope) => {
  scope.emailInputTarget.dispatchEvent(Events.submittedEvent);
  scope.titleTarget.textContent = 'Thank you';
  scope.subtitleTarget.textContent = 'Check your email and confirm your subscription to complete your personalized experience.';
  scope.submitButtonTarget.classList.add('t-hidden');
  scope.investorTypeTarget.classList.add('t-hidden');
  scope.emailTarget.classList.add('t-hidden');
  scope.goBackButtonTarget.classList.add('t-invisible');
  setTimeout(() => {
    scope.closeSurvey();
  }, 3000);
}

const stepAction = {
  1: step1,
  2: step2,
  3: step3
}

export default class extends Controller {
  static targets = [ 'investorType', 'email', 'emailInput', 'headerSurveyContainer', 'headerDropdownContainer', 'headerSurvey', 'headerSurveyContent', 'headerSurveyAd', 'title', 'subtitle', 'submitButton', 'goBackButton', 'errorMessage' ]

  connect() {
    if (this.hasHeaderSurveyContainerTarget && this.hasHeaderSurveyTarget && this.showHeaderSurvey()) {
      this.registerSelectListener();
    }
  }

  showHeaderSurvey() {
    const showHeaderSurvey = Utility.getCookie('show_header_survey');
    if(showHeaderSurvey === 'false' || this.headerSurveyTarget.dataset.premium === 'true' || this.isOnHideSurveyPage()) {
      this.headerSurveyAdTarget.classList.remove('t-opacity-0');
      Utility.setLocalCookies('show_annuity_chatbox', true);
      return false;
    }
    this.headerSurveyContainerTarget.style.maxHeight = !Utility.isScreenSizeOf('sm', true) ? '350px' : '300px';
    this.headerDropdownContainerTarget.style.height = !Utility.isScreenSizeOf('sm', true) ? '350px' : '300px';
    this.headerSurveyTarget.classList.remove('t-hidden');
    Utility.setLocalCookies('show_annuity_chatbox', false);
    Utility.setCookieWithExpiration('show_header_survey', false, this.oneMonth());
    return true;
  }

  isOnHideSurveyPage() {
    const pathname = window.location.pathname.replace(/\//g, '');
    return hidePagePathname.includes(pathname);
  }

  registerSelectListener() {
    if (this.hasInvestorTypeTarget) {
      let investorTypeSelect = this.investorTypeTarget.querySelector('select');
      investorTypeSelect.addEventListener('change', () => {
        userInput.investor_type = investorTypeSelect.selectedOptions[0].id;
        investorTypeSelect.setAttribute('data-investor-type', userInput.investor_type);
        Utility.setCookieWithExpiration('show_header_survey', false, this.forever());
        this.toStep(2);
      });
    }
  }

  onFocus(e) {
    e.target.selectedIndex = 0;
  }

  onEmailInput(e) {
    e.target.setAttribute('data-email', e.target.value);
    e.target.setAttribute('data-newsletter-state', 'true');
    userInput.email = e.target.value;
  }

  onSubscribe() {
    if(this.validateData(userInput.investor_type, userInput.email)){
      // Get current URL without domain (cross-browser compatible)
      const fullUrl = window.location.href;
      const origin = window.location.origin ||
                    (window.location.protocol + "//" + window.location.hostname +
                    (window.location.port ? ':' + window.location.port : ''));
      const currentUrl = fullUrl.substring(origin.length);

      axios.post('/api/newsletter/', {
        email: userInput.email,
        investor_type: userInput.investor_type,
        status: 'pending',
        signup_location: currentUrl
      }).then(() => {
        this.toStep(3);
      }).catch(() => {
        this.emailInputTarget.classList.add('t-border-red-600', 't-border');
        this.errorMessageTarget.classList.remove('t-hidden');
      });
    }
  }

  toStep = (step) => {
    this.headerSurveyContentTarget.classList.add('t-opacity-0');
    this.resetErrorMessage();
    setTimeout(() => {
      stepAction[step](this);
      if(this.hasHeaderSurveyContentTarget) this.headerSurveyContentTarget.classList.remove('t-opacity-0');
    }, 500);
  }

  validateData(investor_type, email) {
    this.resetErrorMessage();
    if(!investor_type || !this.validateEmail(email)) return false;
    return true;
  }

  validateEmail(email) {
    let regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!email || !regex.test(email)) {
      this.emailInputTarget.classList.add('t-border-red-600', 't-border');
      this.errorMessageTarget.classList.remove('t-hidden');
      return false;
    }
    return true;
  }

  resetErrorMessage() {
    this.emailInputTarget.classList.remove('t-border-red-600', 't-border');
    this.errorMessageTarget.classList.add('t-hidden');
  }

  close() {
    this.closeSurvey();
    const showHeaderSurvey = Utility.getCookie('show_header_survey');
    if(showHeaderSurvey === 'unknown') {
      Utility.setCookieWithExpiration('show_header_survey', false, this.oneMonth());
    }
  }

  closeSurvey() {
    this.headerSurveyContainerTarget.style.maxHeight = '0';
    this.headerSurveyContainerTarget.style.minHeight = '0';
    this.headerSurveyTarget.classList.add('t-opacity-0');
    setTimeout(() => {
      this.headerSurveyTarget.classList.add('t-hidden');
    }, 250);
  }

  forever() {
    var max = Math.pow(2, 31) - 1; // maximum 32-bit signed int
    return new Date(max * 1000).toUTCString();
  }

  oneMonth() {
    const now = new Date();
    return this.addMonths(now, 1).toUTCString();
  }

  addMonths(date, months) {
    const d = date.getDate();
    date.setMonth(date.getMonth() + months);
    if (date.getDate() != d) {
      date.setDate(0);
    }
    return date;
  }
}
